import { IxGridNoRows } from './IxGridNoRows.js';

window.customElements.define('ix-grid-no-rows', IxGridNoRows);
